/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import React from 'react';
import { observer } from 'mobx-react';
import { Box, Divider, IconButton, Typography } from '@mui/material';
import { Image } from '../../../../types/elements/Image';
import { ImageSliderView } from '../ImageSlider/ImageSliderView';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { ExpandableViewModel } from './ExpandableViewModel';
import { useViewModel } from '../../../../hooks/useViewModel';
import { ExpandableViewUseStyles } from './ExpandableViewStyles';

interface Props {
	name: string;
	info: string;
	images: Image[];
	last: boolean;
}

export const ExpandableView = observer((props: Props) => {
	const { name, info, images, last } = props;
	const viewModel: ExpandableViewModel = useViewModel(ExpandableViewModel);
	const { classes } = ExpandableViewUseStyles();

	return (
		<>
			<Divider className={classes.divider} />
			<Box className={classes.box}>
				<Typography className={classes.title}>{name}</Typography>
				<IconButton
					className={classes.arrow}
					onClick={() => {
						viewModel.toggleOpen();
					}}>
					{viewModel.isOpen() ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
				</IconButton>
			</Box>
			{viewModel.isOpen() && (
				<Box>
					<Divider className={classes.divider} />
					<Typography className={classes.text}>{info}</Typography>
					{images.length > 0 && (
						<Box className={classes.slider}>
							<ImageSliderView images={images} />
						</Box>
					)}
				</Box>
			)}
			{last && <Divider className={classes.lastDivider} />}
		</>
	);
});
